import { AccredibleTooltipModule } from '@accredible-frontend-v2/new-components/tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccredibleTruncateTextComponent } from './truncate-text.component';

@NgModule({
  imports: [CommonModule, AccredibleTooltipModule],
  declarations: [AccredibleTruncateTextComponent],
  exports: [AccredibleTruncateTextComponent],
})
export class AccredibleTruncateTextComponentModule {}
